<sharry-header></sharry-header>
<div class="index">
  @if (indexTitle === 'category') {
    <ng-container *ngTemplateOutlet="categoryTemplate"></ng-container>
  } @else {
    <ng-container *ngTemplateOutlet="indexTemplate"></ng-container>
  }
</div>
<ng-template #indexTemplate>
  <h1>{{ 'index.title.' + indexTitle | i18next }}</h1>
  <mat-form-field>
    <input
      type="text"
      matInput
      [ngModel]="search"
      [placeholder]="'index.search' | i18next"
      (ngModelChange)="onModelChange($event)" />
  </mat-form-field>
  <p class="bigger index__body-title">
    <strong>{{ 'index.results' | i18next }}</strong>
  </p>
  <div class="index__body">
    @for (item of list$ | async | filterIndex: search; track item; let index = $index; let odd = $odd) {
      <p
        class="index__body__record"
        [class.index__body__record--odd]="odd">
        <span>{{ index + 1 }}</span>
        <a [routerLink]="[activeRoute | routeTranslate, item.key]">{{ item.value }}</a>
      </p>
    }
  </div>
</ng-template>
<ng-template #categoryTemplate>
  <div class="index__categories">
    <h2>{{ 'index.title.' + indexTitle | i18next }}</h2>
    <p [innerHTML]="'index.categories.subtitle' | i18next"></p>
    <div class="index__categories__grid">
      @for (item of list$ | async | filterIndex: search; track item) {
        <a
          class="index__categories__grid--category"
          [routerLink]="[activeRoute | routeTranslate, item.key]">
          <img
            alt="category"
            [width]="50"
            [height]="50"
            [src]="$any(item).icon" />
          <span>{{ item.value }}</span>
        </a>
      }
    </div>
  </div>
</ng-template>
<sharry-footer class="is-not-mobile"></sharry-footer>
